import { ChertoExperiments } from 'constants/experiments'
import { HOMES_AND_VILLAS_HOLIDAY_TYPES_SCOPED, VACATION_RENTAL_HOLIDAY_TYPES_SCOPED } from 'constants/offerList'
import useExperiment from 'hooks/Experiments/useExperiment'

function useHomesAndVillasScopedHolidayTypes(): Array<string> {
  const { isAnyVariant } = useExperiment(ChertoExperiments.homesAndVillasVacationRentalScope)
  return isAnyVariant ? VACATION_RENTAL_HOLIDAY_TYPES_SCOPED : HOMES_AND_VILLAS_HOLIDAY_TYPES_SCOPED
}

export default useHomesAndVillasScopedHolidayTypes
